module.exports = __webpack_public_path__ + "img/scwxsgl.cb915b51.jpg";